<template>
  <div>
    <editor v-model="new_value"/>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  props: ["value"],
  components: {
    editor: VueEditor,
  },
  data() {
    return {
      new_value: "",
    };
  },
  watch: {
    value: {
      handler() {
        this.new_value = this.getValue;
      },
    },
    new_value: {
      handler() {
        this.$emit("input", this.new_value);
      },
    },
  },
  computed: {
    getValue() {
      return this.value;
    },
  },
};
</script>

<style>
.tox-notifications-container {
  display: none !important;
}
</style>